module.exports = __webpack_public_path__ + "img/empty.785ffc8c.svg";